import * as React from 'react';

function SvgCustomerIcon(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.275 11.202a4.509 4.509 0 001.558-3.41 4.583 4.583 0 00-9.166 0 4.51 4.51 0 001.558 3.41 7.333 7.333 0 00-4.308 6.673.917.917 0 001.833 0 5.5 5.5 0 0111 0 .917.917 0 001.833 0 7.334 7.334 0 00-4.308-6.673zm-3.025-.66a2.75 2.75 0 110-5.5 2.75 2.75 0 010 5.5zm8.928.293a4.584 4.584 0 00-3.428-7.627.917.917 0 000 1.834 2.75 2.75 0 012.75 2.75 2.75 2.75 0 01-1.375 2.374.916.916 0 00-.046 1.558l.357.239.12.064a6.416 6.416 0 013.666 5.848.917.917 0 001.834 0 8.25 8.25 0 00-3.878-7.04z"
        fill="#748CAD"
      />
    </svg>
  );
}

export default SvgCustomerIcon;
